import React from 'react';
export function ClockIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-132">
      <circle cx="12" cy="12" r="10" data-id="element-133" />
      <polyline points="12 6 12 12 16 14" data-id="element-134" />
    </svg>;
}